// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6454a78a","453":"3c6a2d40","455":"839dbb62"}[chunkId] + ".chunk.js";
};